"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("../style.sass");

require("../responsive.sass");

require("../mobile-version.sass");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var media1 = 'https://homepages.cae.wisc.edu/~ece533/images/baboon.png';

var View = function View(props) {
  return /*#__PURE__*/_react["default"].createElement("section", {
    className: "wizrd-blog-detail-wrapper modifyDetail"
  }, props.children);
};

var _default = View;
exports["default"] = _default;